import { Component, OnInit } from '@angular/core';
import { loadingFade, modal, alert } from '../../animacoes';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FiltroPipe } from '../pipes/filtro.pipe';
import * as moment from 'moment';

import { VeiculoService } from '../services/veiculo.service';
import { ClienteService } from '../services/cliente.service';
import { UnidadeService } from '../services/unidade.service';
import { MarcaVeiculoService } from '../services/marca-veiculo.service';
import { ModeloVeiculoService } from '../services/modelo-veiculo.service';
import { ExcelService } from '../services/excel.service';
import { AuthService } from '../services/auth.service';
import { TipoVeiculoService } from '../services/tipo-veiculo.service';
import { ActivatedRoute, Router } from "@angular/router";
import { PerfilUsuarioService } from '../services/perfil-usuario.service';

import Swal from 'sweetalert2';

@Component({
	selector: 'app-veiculos',
	templateUrl: './veiculos.component.html',
	styleUrls: ['./veiculos.component.css'],
	animations: [loadingFade, modal, alert]
})
export class VeiculosComponent implements OnInit {

    //Id do menu da tb_menu
    public menu_id = 105; //veiculos

	public loading = false;
	public veiculos = [];
	public veiculosFiltro = [];
	public clientes = [];
	public unidades = [];
	public tiposVeiculo = [];
	public modelosVeiculo = [];
	public marcasVeiculo = [];
	public tipoVeiculo = [];
	public usuario_perfil;
	public visualizar = true;
	public editar = false;

	// paginacao
	public page = 1;
	public limit = 10;
	public count = 0;

	// filtro
	public filtro = [];
	public dadosFiltrados = [];
	public formFiltro: FormGroup;
	public showFilter = true;

	constructor(private fb: FormBuilder,
				private authSvc: AuthService,
				private veiculoSvc: VeiculoService,
				private clienteSvc: ClienteService,
				private unidadeSvc: UnidadeService,
				private modeloVeiculoSvc: ModeloVeiculoService,
				private marcaVeiculoSvc: MarcaVeiculoService,
				private tipoVeiculoSvc: TipoVeiculoService,
				private excelSvc: ExcelService,
				private route: ActivatedRoute,
				private router: Router,
				private perfilUsuarioSvc: PerfilUsuarioService) { }

	ngOnInit() {

		//Verifica Permissões Acesso
		this.usuario_perfil = this.authSvc.getPerfil();
		this.perfilUsuarioSvc.getByVerificaPermissao(this.usuario_perfil,this.menu_id).then((data: any[]) => {
		if(data[0].editar){
			this.editar = true;
		}
		}).catch((err) => {
		console.log(err);
		});  

		this.criaFiltro();
		this.pegaVeiculos();
	}

	veiculoComponent(){

		this.veiculoSvc.testeToken(this.authSvc.getUsuarioId()); 

	}

	pegaVeiculos() {
		this.veiculos = [];
		this.loading = true;
		
		this.veiculoSvc.getVeiculosByUsuario(this.authSvc.getUsuarioId()).then((data: any) =>{
			this.veiculos = data;
			this.count = this.veiculos.length;
			this.loading = false;
		}).catch((err) => {
			console.log(err);
			this.loading = false;
		})
	}

	primPagina() {
		this.page = 1;
	}

	paginaAnt() {
		this.page = Math.max(this.page - 1, 1);
	}

	proxPagina() {
		this.page = Math.min(this.page + 1, Math.ceil(this.count / this.limit));
	}

	ultPagina() {
		this.page = Math.ceil(this.count / this.limit);
	}

	exportarExcel(){
		let data = [];
		if(this.dadosFiltrados.length == 0){
			this.dadosFiltrados = this.veiculos;
		}
		for(let index in this.dadosFiltrados){
			data[index] = {
				'Central': this.dadosFiltrados[index].cliente.cliente_nome,
				'Unidades': this.dadosFiltrados[index].unidade.unidade_nome,
				'Tipo de Veículo': this.dadosFiltrados[index].tipo.tipo_veiculo_nome,
				'Fabricante': this.dadosFiltrados[index].marca.marca_veiculo_nome,
				'Veículo': this.dadosFiltrados[index].veiculo_numero,
				'Placa': this.dadosFiltrados[index].veiculo_placa,
				'Renavan': this.dadosFiltrados[index].veiculo_renavam,
				'Modelo': this.dadosFiltrados[index].modelo.modelo_veiculo_nome,
				'Status': this.dadosFiltrados[index].veiculo_status === "S" ? 'Ativo' : 'Inativo',				
				'Ano Fabricação': this.dadosFiltrados[index].veiculo_ano_fabricacao,
				'Ano Modelo': this.dadosFiltrados[index].veiculo_ano_modelo,
				'Tipo': this.dadosFiltrados[index].tipo.tipo_veiculo_nome,
				'Especialidade': this.dadosFiltrados[index].especialidade.especialidade_veiculo_nome,
				'Cor': this.dadosFiltrados[index].cor_veiculo.cor_veiculo_nome,
			};
		}

		this.excelSvc.exportAsExcelFile(data, 'Chronos Frota - Veiculos');
	}

	criaFiltro() {
		this.pegaClientes();
		this.pegaUnidades();
		this.pegaModelosVeiculo();
		this.pegaMarcasVeiculo();
		this.pegaTiposVeiculo();
		
		this.formFiltro = this.fb.group({
			cliente_id___cliente:null,
			unidade_id___unidade:null,
			veiculo_id___veiculo:null,
			veiculo_placa___placa:null,
			marca_veiculo_id___veiculo:null,
			modelo_veiculo_id___veiculo:null,
			veiculo_id___FiltroVeiculo: null,
			tipo_veiculo_id___veiculo: null,
			veiculo_status___status: null
		});
	}

	filtra() {

		this.filtro = this.formFiltro.value;
		this.dadosFiltrados = new FiltroPipe().transform(this.veiculos, this.filtro);
		this.count = this.dadosFiltrados.length;
		this.page = 1;
	}

	pegaClientes(){
		this.clienteSvc.getClientesByUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
			this.clientes = data;
		});
	}

	onChangeCliente(evento){
		this.formFiltro.controls.unidade_id___unidade.setValue(null);
		this.unidadeSvc.getUnidadesByUsuarioAndCliente(this.authSvc.getUsuarioId(), evento.cliente_id).then((data: any) => {
			this.unidades = data;
		}).catch((err) => {
			console.log(err);
		});
	}
	
	pegaUnidades(){
		this.unidadeSvc.getUnidadesByUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
			this.unidades = data;
		}).catch((err) => {
			console.log(err);
		});
	}

	pegaModelosVeiculo(){
		this.modeloVeiculoSvc.getModelosVeiculo().then((data: any[])=> {
			this.modelosVeiculo = data;
		});
	}

	
	pegaMarcasVeiculo(){
		this.marcaVeiculoSvc.getMarcasVeiculo().then((data: any[])=> {
			this.marcasVeiculo = data;
		});
	}
	
	onChangeMarca(evento){
		this.formFiltro.controls.modelo_veiculo_id___veiculo.setValue(null);
		this.modeloVeiculoSvc.getModelosVeiculoByMarca(evento.marca_veiculo_id).then((data: any[])=> {
			this.modelosVeiculo = data;
		});
	}
	expandPanel(){
		this.showFilter = this.showFilter == true ? false: true;
	}

	
	onChangeStatus(manutencao_id, event){
		this.loading = true;
		let toSend = ({
		  'veiculo_id': manutencao_id,
		  'veiculo_status': event.srcElement.checked,
		});
		
		this.veiculoSvc.editaVeiculo(toSend).then((data) => {
		  console.log('resp', data);
		  this.loading = false;
		  Swal.fire({
			type: 'success',
			title: 'Status alterado com sucesso!'
		  });
		}).catch(err => {
		  console.log(err);
		  this.loading = false;
		  Swal.fire({
			type: 'error',
			title: 'Ops! Algo de errado aconteceu!',
			text: 'Tente novamente mais tarde.'
		  });
		});
	}

	apagaVeiculo(id: any) {
		Swal.fire({
			type:'warning',
			title: 'Deseja realmente apagar este registro?',
			showCancelButton: true,
			showCloseButton: true,
			confirmButtonText: 'Apagar',
			cancelButtonText: 'Cancelar',
			confirmButtonColor: '#d33'
			  
		}).then((result) => {
			if(result.value == true){
				this.veiculoSvc.apagaVeiculo(id).then(() => {
					this.pegaVeiculos();
					Swal.fire({
						type: 'success',
						title: 'Apagado com sucesso!'
					});
				}).catch((err) => {
					console.log(err);
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Não foi possível apagar este registro, tente novamente mais tarde.'
					});
				});
			}
		})
	}

	onChangeVeiculoUnidade(e){
		this.pegaVeiculoUnidadeProfissional(e);
	  }
	
	  pegaVeiculoUnidadeProfissional(e){

		if(typeof e === 'undefined'){
			return "";
		}else{   

			this.loading = true;
			this.veiculosFiltro = [];
			this.veiculoSvc.getByVeiculoClienteUnidadeEspecialidade(e.cliente_id,e.unidade_id,"todos").then((data: any[]) => {
		
			let dados = [];
			for(let veiculo of data){
			  dados.push({
			  veiculo_id: veiculo.veiculo_id,
			  placa_numero: veiculo.veiculo_placa + ' - ' + veiculo.veiculo_numero,
			  unidade_id: e.unidade_id,
			  cliente_id: e.cliente_id
			  });
			}
	  
	  
			this.veiculosFiltro = dados;
		
			this.loading = false;
			}).catch((err) => {
			console.log(err);
			});

		}

 	}
	  
	  pegaTiposVeiculo() {
		this.tipoVeiculo = [];
		this.loading = true;
		this.tipoVeiculoSvc.getTiposVeiculo().then((data: any[]) => {
			this.tipoVeiculo = data;
		}).catch((err) => {
			console.log(err);
		})
	}
	
	clickLimparCampos(){
		this.formFiltro = this.fb.group({
			cliente_id___cliente:null,
			unidade_id___unidade:null,
			veiculo_id___veiculo:null,
			veiculo_placa___placa:null,
			marca_veiculo_id___veiculo:null,
			modelo_veiculo_id___veiculo:null,
			veiculo_id___FiltroVeiculo: null,
			tipo_veiculo_id___veiculo: null,
			veiculo_status___status: null
		});
    }
	
	
	VerVeiculo(veiculo_id){

		this.filtro = this.formFiltro.value;

		let params = '';

		for (let f in this.filtro) {
			let val = this.filtro[f];
			if (val) {
				let aux = f.split('___');
				if (aux[1] == 'data_i' || aux[1] == 'data_f')
					val = moment(val, 'DD/MM/YYYY').format('YYYY-MM-DD');

				params += (params == '')? '?' : '&';
				params += f + "=" + val;
			}
		}

		//veiculos
		this.router.navigate(['home/veiculos/edit/' + veiculo_id + params + "/ver"] );
	}

}
